var app = angular.module("leonardo");

var CountriesStates = function($stateProvider) {
  $stateProvider.state('countries', {
    url: '/countries',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'countries.list',
    ncyBreadcrumb: {
      label: 'Countries'
    }
  });

  $stateProvider.state('countries.list', {
    url: "/list/:pk",
    title: 'Countries List',
    params: {
      pk: '',
      squash: false
    },
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/country/list.html',
        controller: 'CountryList'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/country-list.html'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'LevelListFilter'
      }
    },
    ncyBreadcrumb: {
      label: 'List'
    }
  });

  $stateProvider.state('countries.edit', {
    url: "/:pk/edit",
    title: 'Countries Edit',
    params: {
      pk: '',
      squash: false
    },
    action: 'edit',
    views: {
      'content@authenticated.layout-main': {
        controller: 'CountryFormController',
        templateUrl: 'views/templates/country/form.html'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/country-list.html'
      }
    },
    resolve: {
      formObj: ['CountryService', '$stateParams', function(CountryService, $stateParams) {
        return CountryService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'Edit'
    }
  });

  $stateProvider.state('countries.add', {
    url: "/add",
    title: 'Add countries',
    action: 'create',
    views: {
      'content@authenticated.layout-main': {
        controller: 'CountryFormController',
        templateUrl: 'views/templates/country/form.html'
      }
    },
    ncyBreadcrumb: {
      label: 'Create'
    },
    resolve: {
      formObj: ['CountryService', function(CountryService) {
        return {};
      }]
    }
  });

  $stateProvider.state('countries.levels', {
    url: "/:country/levels/:parent",
    // title: 'Country Levels',
    params: {
      parent: '',
      squash: false
    },
    views: {
      'content@authenticated.layout-main': {
        controller: 'LevelsListController',
        templateUrl: 'views/templates/country/levels-list.html'
      },
      'actions@authenticated.layout-main': {
        controller: 'LevelsActionsController',
        templateUrl: 'views/templates/actions/levels-list.html'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'LevelListFilter'
      },
      'breadcrumb@authenticated.layout-main': {
        templateUrl: 'views/templates/country/levels-breadcrumb.html',
        controller: 'LevelBreadCrumb'
      }
    },
    resolve: {
      parentObj: ['LevelService', '$stateParams', function(LevelService, $stateParams) {
        return $stateParams.parent ? LevelService.get($stateParams.parent, true) : null;
      }],
      countryObj: ['CountryService', '$stateParams', function(CountryService, $stateParams) {
        return CountryService.get($stateParams.country, true);
      }]
    },
    ncyBreadcrumb: {
      label: 'Levels'
    }
  });

  $stateProvider.state('countries.levels.add', {
    url: "/add",
    // title: 'Add Level',
    views: {
      'content@authenticated.layout-main': {
        controller: 'LevelsFormController',
        templateUrl: 'views/templates/country/level-form.html'
      },
      'actions@authenticated.layout-main': {},
      'filters@authenticated.layout-main': {}
    },
    resolve: {
      parentObj: ['LevelService', '$stateParams', function(LevelService, $stateParams) {
        return $stateParams.parent ? LevelService.get($stateParams.parent, true) : null;
      }],
      levelObj: ['LevelService', function(LevelService) {
        return {};
      }],
      countryObj: ['CountryService', '$stateParams', function(CountryService, $stateParams) {
        return CountryService.get($stateParams.country, true);
      }]
    },
    ncyBreadcrumb: {
      label: 'Add'
    }
  });

  $stateProvider.state('countries.levels.edit', {
    url: "/edit/:pk",
    // title: 'Edit Level',
    params: {
      pk: '',
      squash: false
    },
    action: 'edit',
    views: {
      'content@authenticated.layout-main': {
        controller: 'LevelsFormController',
        templateUrl: 'views/templates/country/level-form.html'
      },
      'actions@authenticated.layout-main': {},
      'filters@authenticated.layout-main': {}
    },
    resolve: {
      parentObj: ['LevelService', '$stateParams', function(LevelService, $stateParams) {
        return $stateParams.parent ? LevelService.get($stateParams.parent, true) : null;
      }],
      levelObj: ['LevelService', '$stateParams', function(LevelService, $stateParams) {
        return LevelService.get($stateParams.pk, true);
      }],
      countryObj: ['CountryService', '$stateParams', function(CountryService, $stateParams) {
        return CountryService.get($stateParams.country, true);
      }]
    },
    ncyBreadcrumb: {
      label: 'Edit'
    }
  });

};

app.config(['$stateProvider', CountriesStates]);
